<template>
  <div class="pb-10">
    <CustomPageHeaderVue class="flex-grow-0">電子票券匣</CustomPageHeaderVue>
    <CustomRow>
      <div class="mt-5 d-flex text-title">
        <div
          class="cus-tab left-tab cursor-pointer text-regular text-sm-big-title"
          :class="{ inactive: tabSelect !== 0 }"
          @click="changeTab('current')"
        >
          我的票券
        </div>
        <div
          class="cus-tab right-tab cursor-pointer text-regular text-sm-big-title"
          :class="{ inactive: tabSelect !== 1 }"
          @click="changeTab('history')"
        >
          歷史票券
        </div>
      </div>
      <v-tab-transition>
        <v-card :class="`py-4 px-3 py-md-6 px-md-12 tab-content`">
          <v-sheet
            v-if="isLoading"
            :height="
              $vuetify.breakpoint.xs ? 195 : $vuetify.breakpoint.sm ? 300 : 400
            "
            width="100%"
            class="text-center"
          >
            <v-progress-circular
              :width="3"
              color="primary-1"
              indeterminate
              style="margin-top: 54px"
            ></v-progress-circular>
          </v-sheet>
          <template v-else>
            <div
              class="empty-result"
              v-if="
                (tabSelect === 0 && !etickets.length) ||
                (tabSelect === 1 && !history.length)
              "
            >
              <div class="mb-3 font-weight-regular">暫無任何票券</div>
              <v-btn
                @click="$router.push({ name: 'Index' }).catch(() => {})"
                class="nextBtn"
                depressed
                rounded
                >查看熱門活動</v-btn
              >
            </div>
            <!---->
            <template v-else>
              <v-card
                class="ticket"
                v-for="ticket in tabSelect === 0 ? etickets : history"
                :key="ticket.ticketNum"
              >
                <div class="card-header px-3 py-4 px-md-9 pt-md-6">
                  <div class="eventImage">
                    <img
                      :src="
                        ticket[
                          $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                            ? 'orderEventSmallThumbnail'
                            : 'orderEventBigThumbnail'
                        ]
                      "
                      :class="`mr-3 mr-md-0 ${
                        $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                          ? 'float-left'
                          : ''
                      }`"
                      :width="`${
                        $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                          ? 108
                          : 240
                      }`"
                    />
                  </div>
                  <div class="font-weight-bold mt-0 mt-md-3">
                    {{ ticket.sessionName }}
                  </div>
                </div>
                <div class="card-body py-4 px-3 py-md-6 px-md-9">
                  <v-row>
                    <v-col cols="2" class="grey-darken-0">票區</v-col>
                    <v-col cols="4" class="font-weight-medium">{{
                      ticket.seatInfo.area
                    }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" class="grey-darken-0">座位</v-col>
                    <v-col cols="4" class="font-weight-medium">{{
                      ticket.seatInfo.seat
                    }}</v-col>
                    <v-col cols="2" class="grey-darken-0">序號</v-col>
                    <v-col cols="4" class="font-weight-medium">{{
                      ticket.entrySN
                    }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" class="grey-darken-0">票種</v-col>
                    <v-col cols="4" class="font-weight-medium">{{
                      ticket.productName
                    }}</v-col>
                  </v-row>
                  <v-divider background-color="eaeaea" class="my-4" />
                  <div class="font-weight-medium">
                    <div>
                      {{
                        ticket.displaySessionDate ||
                        dateFotmat(ticket.sessionStart, true)
                      }}
                    </div>
                    <div>{{ ticket.sessionLocation }}</div>
                    <div>張數：{{ ticket.index }}</div>
                  </div>
                  <v-divider background-color="eaeaea" class="my-4 d-md-none" />
                  <div class="mt-md-5 text-right">
                    <template v-if="tabSelect === 1">
                      <v-btn
                        depressed
                        outlined
                        class="pa-3 pa-md-5 nextBtn"
                        height="auto"
                        @click="showTicket(ticket)"
                        :block="
                          $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                        "
                        >查看票券
                      </v-btn></template
                    >
                    <template v-else>
                      <template
                        v-if="
                          !(ticket.eTicketPickStart && ticket.eTicketPickEnd)
                        "
                      >
                        <v-btn
                          depressed
                          class="pa-3 pa-md-5"
                          height="auto"
                          :block="
                            $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                          "
                          disabled
                        >
                          尚未啟用
                        </v-btn>
                      </template>
                      <template v-else-if="isExpired(ticket)">
                        <v-btn
                          depressed
                          outlined
                          class="pa-3 pa-md-5 nextBtn"
                          height="auto"
                          @click="showTicket(ticket)"
                          :block="
                            $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                          "
                          >查看票券
                        </v-btn>
                      </template>
                      <template v-else>
                        <v-btn
                          v-if="isInPickupTime(ticket)"
                          depressed
                          class="pa-3 pa-md-5 nextBtn"
                          height="auto"
                          @click="showTicket(ticket)"
                          :block="
                            $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                          "
                          >驗票入場
                        </v-btn>
                        <v-btn
                          depressed
                          class="pa-3 pa-md-5"
                          height="auto"
                          v-else
                          :block="
                            $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                          "
                          disabled
                        >
                          {{ dateFotmat(ticket.eTicketPickStart) }}<br />
                          啟用
                        </v-btn>
                      </template>
                    </template>
                  </div>
                </div>
              </v-card>
            </template>
          </template>
        </v-card>
      </v-tab-transition>
    </CustomRow>

    <v-dialog
      v-model="ticketDialog.show"
      :width="400"
      :height="'auto'"
      :persistent="true"
    >
      <div
        :class="`ticket-dialog ${
          tabSelect === 1 || isExpired(ticketDialog.ticket) ? 'is-expired' : ''
        }`"
        v-if="!!ticketDialog.ticket"
      >
        <div class="ticket-dialog-head">
          <div>
            <small
              style="position: absolute; left: 4px; top: 4px; opacity: 0.75"
              >{{ errNo }}
              {{ new Date(ticketDialog.ticket.sessionEnd).valueOf() }}</small
            >
            {{ ticketDialog.ticket.seatInfo.area }}
          </div>
          <h3>{{ ticketDialog.ticket.seatInfo.seat }}</h3>
          <div class="primary-1--text font-weight-medium mt-4">
            {{ ticketDialog.ticket.productName }}
          </div>
        </div>
        <div class="ticket-dialog-divider">
          <div class="left"></div>
          <div class="center"></div>
          <div class="right"></div>
        </div>
        <div class="ticket-dialog-body pb-8">
          <div class="qr-code">
            <template v-if="tabSelect === 1">
              <img
                v-if="
                  ticketDialog.ticket.verifiedStatus &&
                  ticketDialog.ticket.ticketStatus === 1
                "
                src="@/assets/image/ticket_verified.png"
                width="200"
                class="verified-stamp"
              />
              <img
                v-else-if="
                  !ticketDialog.ticket.verifiedStatus &&
                  ticketDialog.ticket.ticketStatus === 1 &&
                  !ticketDialog.qrCode
                "
                src="@/assets/image/ticket_expired.png"
                width="200"
                class="verified-stamp"
              />
              <img
                v-else
                :src="ticketDialog.qrCode"
                width="200"
                class="verified-stamp"
              />
            </template>
            <template v-else>
              <v-img
                v-if="
                  ticketDialog.ticket.verifiedStatus &&
                  ticketDialog.ticket.ticketStatus === 1
                "
                src="@/assets/image/ticket_verified.png"
                width="200"
                class="mx-auto mb-3"
              />
              <v-img
                v-else
                :src="ticketDialog.qrCode"
                width="200"
                class="mx-auto mb-3"
              />
            </template>
            <!-- <img
              v-if="
                ticketDialog.ticket.verifiedStatus &&
                  ticketDialog.ticket.ticketStatus === 1
              "
              src="@/assets/image/ticket_verified.png"
              width="200"
              class="verified-stamp"
            />
            <img
              v-else-if="
                !ticketDialog.ticket.verifiedStatus &&
                  ticketDialog.ticket.ticketStatus === 1
              "
              src="@/assets/image/ticket_expired.png"
              width="200"
              class="verified-stamp"
            />
            <v-img
              v-else
              :src="ticketDialog.qrCode"
              width="200"
              class="mx-auto mb-3"
            /> -->
          </div>
          <div class="red--text mb-5" v-if="ticketDialog.ticket.verifiedStatus">
            {{ dateFotmat(ticketDialog.ticket.verifiedTime) }} 驗票入場
          </div>
          <h2
            v-if="
              tabSelect === 0 &&
              !isExpired(ticketDialog.ticket) &&
              !ticketDialog.ticket.verifiedStatus
            "
            class="d-flex justify-center align-center orange--text"
          >
            {{
              `${Math.floor(ticketDialog.countdown / 60)}:${leftPad(
                ticketDialog.countdown % 60
              )}`
            }}
            <img
              src="@/assets/image/sync.svg"
              width="22"
              height="22"
              class="ml-1"
              @click="showTicket(ticketDialog.ticket)"
              role="button"
            />
          </h2>
          <div
            v-if="ticketDialog.ticket.identityName"
            class="mb-5 mt-7 primary-1--text"
          >
            參加者姓名：{{ ticketDialog.ticket.identityName }}
          </div>
          <div class="font-weight-medium">{{ ticketDialog.ticket.index }}</div>
        </div>
        <v-btn icon color="primary-1" class="float-btn" @click="closeTicket"
          ><v-icon small color="white">mdi-close</v-icon>
        </v-btn>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import CustomPageHeaderVue from "@/components/CustomPageHeader.vue";
import { mapActions } from "vuex";
import { encrypt, decrypt } from "@/vendor/crypto";
import { getSessions } from "@/api/static";
import ET from "@/api/eticket-management";
import CC from "@/api/config-center";

export default {
  props: ["tab"],
  components: {
    CustomPageHeaderVue,
  },
  metaInfo() {
    return {
      title: `電子票券匣-${this.$t("app_name")}`,
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: `電子票券匣-${this.$t("app_name")}`,
            url: window.location.origin + window.location.pathname,
          },
        },
      ],
      meta: [
        {
          name: "robots",
          content: "noindex, nofollow",
        },
      ],
    };
  },
  data() {
    return {
      tabs: ["current", "history"],
      isOver: false,
      etickets: [],
      history: [],
      countdown: null,
      isLoading: true,
      errNo: "",
      ticketDialog: {
        ticket: null,
        timer: 300,
        show: false,
      },
    };
  },
  computed: {
    tabSelect() {
      return this.tab
        ? this.tabs.indexOf(this.tab) > -1
          ? this.tabs.indexOf(this.tab)
          : 0
        : 0;
    },
  },
  watch: {
    "ticketDialog.show": function (val, v) {
      if (!val && this.countdown) {
        clearInterval(this.countdown);
      }
    },
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show",
    }),
    isExpired(ticket) {
      const today = new Date().valueOf();
      const end = new Date(ticket.sessionEnd || ticket.sessionsDateTime);
      return (
        end.valueOf() + 86400000 <= today &&
        today > new Date(ticket.eTicketPickEnd).valueOf()
      );
    },
    isInPickupTime(ticket) {
      const today = new Date().valueOf();
      return (
        new Date(ticket.eTicketPickStart).valueOf() <= today &&
        today <= new Date(ticket.eTicketPickEnd).valueOf()
      );
    },
    leftPad(num) {
      return num.toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    },
    dateFotmat(date, showDay) {
      const dt = new Date(date);
      const week = ["日", "一", "二", "三", "四", "五", "六"];
      return `${dt.getFullYear()}-${this.leftPad(
        dt.getMonth() + 1
      )}-${this.leftPad(dt.getDate())}${
        showDay ? `(${week[dt.getDay()]})` : ""
      } ${this.leftPad(dt.getHours())}:${this.leftPad(dt.getMinutes())}`;
    },
    changeTab(type) {
      this.$router
        .push({ name: "TicketTab", params: { tab: type } })
        .catch(() => {});
    },
    closeTicket() {
      clearInterval(this.countdown);
      this.ticketDialog = {
        ticket: null,
        show: false,
        timer: 300,
        countdown: 0,
        qrCode: null,
      };
    },
    async showTicket(ticket) {
      let qrCode = null;
      let tick = ticket;
      // if (
      //   ticket.ticketStatus === 1 &&
      //   !ticket.verifiedStatus &&
      //   !this.isExpired(ticket)
      // ) {
      const { data } = await ET.generateQrcode({
        ticketNum: ticket.ticketNum,
      });

      if (data.errCode === "101") {
        tick.ticketStatus = 1;

        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
                <img
                  src="/image/ic-warning@3x.png"
                  alt=""
                  style="width:80px"
                />
                <div class="mt-5">${this.$t("generator_qrcode_fail")}</div>
              </div>`,
        });
      } else {
        if (data.errCode === "104" || data.errCode === "140") {
          tick.verifiedStatus = true;
          tick.ticketStatus = 1;
        }
        if (data.errCode === "00") {
          qrCode = data.item;
        }
        // }

        this.ticketDialog = {
          ticket: tick,
          show: true,
          timer: new Date().valueOf() + 300 * 1000,
          countdown: 300,
          qrCode,
        };
      }
      if (this.tabSelect === 0 && qrCode) {
        if (this.countdown) clearInterval(this.countdown);
        this.$forceUpdate();

        this.countdown = setInterval(() => {
          const countdown = Math.floor(
            (this.ticketDialog.timer - new Date().valueOf()) / 1000
          );
          this.ticketDialog.countdown = countdown <= 0 ? 0 : countdown;
          if (countdown <= 0) {
            clearInterval(this.countdown);
            this.showDialog({
              title: this.$t("ticket_expired_title"),
              content: this.$t("ticket_expired_content"),
              buttons: [
                {
                  text: this.$t("layout_notification_cancel"),
                  style: {
                    block: true,
                    outlined: true,
                    color: "primary",
                  },
                  action: () => {
                    this.ticketDialog.show = false;
                  },
                },
                {
                  text: this.$t("ticket_update"),
                  style: {
                    block: true,
                    outlined: false,
                    color: "primary",
                  },
                  action: () => {
                    if (this.ticketDialog.show)
                      this.showTicket(this.ticketDialog.ticket);
                  },
                },
              ],
            });
          }
        }, 1000);
      }
    },
    async getETicket() {
      const { data } = await ET.getTickets();
      if (data.errCode === "00") {
        let tickets = [];
        const [{ data: infoData }, getInfosErr] = await CC.getInfos({
          sessionId: data.item.reduce((acr, i) => {
            if (!acr.includes(i.sessionId)) acr.push(i.sessionId);
            return acr;
          }, []),
        });

        if (getInfosErr) {
          this.errNo += "[001]";
        }
        await Promise.all(
          data.item.map(async (i, index) => {
            const session = infoData.result.session.find(
              (s) => s.id === i.sessionId
            );
            if (!session) {
              this.errNo += "[002]";
            }
            if (i.eventId) {
              const { data: sessionsData } = await getSessions(
                encrypt(i.eventId)
              );
              const data = sessionsData.sessions.find((s) => {
                return decrypt(s.sessionId) === i.sessionId;
              });
              tickets.push({
                ...i,
                ...session,
                displaySessionDate:
                  data?.date && data?.time
                    ? `${
                        data.date.indexOf("~") > -1
                          ? data.date.split(" ~ ")[0]
                          : data.date
                      } ${
                        data.time.indexOf("~") > -1
                          ? data.time.split(" ~ ")[0]
                          : data.time
                      }`
                    : null,
              });
            } else
              tickets.push({
                ...i,
                ...session,
              });
          })
        );

        tickets = tickets.sort((a, b) => {
          if (b.sessionId === a.sessionId) {
            if (a.orderNum === b.orderNum)
              return (
                Number(a.index.split("/")[0]) - Number(b.index.split("/")[0])
              );
            else return Number(b.orderNum) - Number(a.orderNum);
          } else {
            return new Date(b.sessionStart) - new Date(a.sessionStart);
          }
        });

        const current = new Date(new Date().toLocaleDateString()).valueOf();
        this.history = tickets.filter((it) => {
          if (
            (!it.sessionEnd || it.sessionEnd === "") &&
            this.errNo.indexOf("003") === -1
          )
            this.errNo += "[003]";
          return new Date(it.sessionEnd).valueOf() + 86400000 * 2 < current;
        });
        this.etickets = tickets.filter((it) => {
          return new Date(it.sessionEnd).valueOf() + 86400000 * 2 >= current;
        });

        this.isLoading = false;
      }
    },
  },
  async beforeMount() {
    await this.getETicket();
  },
  mounted() {
    setTimeout(() => {
      this.$gtm.trackView(`Ticket`, this.$route.path);
    }, 200);
  },
};
</script>

<style lang="scss" scoped>
.float-btn {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -64px;
  margin: auto;
  background-color: $primary;
}

::v-deep {
  .v-btn .v-btn__content {
    line-height: 1.25;
  }
}

.cus-tab {
  width: 50%;
  position: relative;
  z-index: 0;
  display: flex;
  align-content: center;
  justify-content: center;
  line-height: 1.5;
  padding-top: 9px;
  padding-bottom: 9px;
  text-align: center;
  font-weight: bold;
  color: #444444;

  &.left-tab {
    z-index: 1;

    &.inactive {
      z-index: 0;
    }

    &::before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      outline: 1px solid transparent;
      border-radius: $radiusDesktop $radiusDesktop 0 0;
      background: white;
      content: "";
      -webkit-transform: perspective(5px) rotateX(0.93deg) translateZ(-1px);
      transform: perspective(8px) rotateX(1.1deg) translateZ(-1px);
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      box-shadow: -2px -2px 6px 0px rgb(0 0 0 / 9%);
    }
  }

  &.center-tab {
    z-index: 1;

    &.inactive {
      z-index: 0;
    }

    &::before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      outline: 1px solid transparent;
      border-radius: $radiusDesktop $radiusDesktop 0 0;
      background: white;
      content: "";
      -webkit-transform: perspective(5px) rotateX(0.93deg) translateZ(-1px);
      transform: perspective(20px) rotateX(5.1deg) translateZ(0px);
      -webkit-transform-origin: 0 0;
      transform-origin: 50% 0;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      box-shadow: 0px -8px 13px -1px rgb(0 0 0 / 9%);
    }
  }

  &.right-tab {
    z-index: 1;
    padding-left: 20px;

    &.inactive {
      z-index: 0;
    }

    &::before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      outline: 1px solid transparent;
      border-radius: $radiusDesktop $radiusDesktop 0 0;
      background: white;
      content: "";
      -webkit-transform: perspective(5px) rotateX(0.93deg) translateZ(-1px);
      transform: perspective(8px) rotateX(1.1deg) translateZ(-1px);
      -webkit-transform-origin: 100% 0;
      transform-origin: 100% 0;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      box-shadow: 2px -2px 6px 0px rgb(0 0 0 / 9%);
    }
  }

  &.inactive {
    font-weight: 400;
  }

  @media screen and (max-width: 600px) {
    &.left-tab::before,
    &.center-tab::before,
    &.right-tab::before {
      border-radius: $radiusMobile $radiusMobile 0 0;
    }
  }
}

::v-deep {
  .v-dialog {
    overflow: visible;
  }
}

.ticket-dialog {
  display: flex;
  flex-direction: column;
  background-color: none;
  box-shadow: none !important;
  position: relative;
  overflow: visible;

  .verified-stamp {
    margin: auto;
    display: none;
  }

  &.is-expired .qr-code {
    position: relative;

    .verified-stamp {
      display: block;
    }
    /**
    .v-image {
      opacity: 0.1;
    }
       */
  }

  .ticket-dialog-divider {
    display: flex;

    .left,
    .right {
      display: block;
      width: 15px;
      height: 32px;
      background-size: contain;
    }

    .left {
      background-image: url("data:image/png;base64,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");
    }

    .right {
      background-image: url("data:image/png;base64,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");
    }

    .center {
      flex: 1;
      flex-grow: 1;
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAABgCAYAAAB1ydDiAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFdSURBVHgB7dWxTsJAHMfxfwtSo9FISEx0UjccWX0MX8O38Vl8BB3d1E0XIzKQYkhaWlprD2MihPItW4ffZ2DgLu336B31xvGssAbxrWEURBREFEQURBREFEQURBREFEQURBREFEQURBREFEQURBREFEQURBREvKJkDdJ2H8+TuQ2jbGngZK9ll0cd28brNLO36Xzpu27g26AX1L2EebdPX8UwztcODnoduz7btzru3iN7GCVrx9zibvqHVodfFeM8jtNyxRldY/HLVMU4wyi3+9HMSJh+86YOk5ym2CTlOZ8xzwmTGkHdoGU4p8Nzzg92cM5p+Wh993yrXB0H5YXaxjdrL/ZbFXePTeN/dlve77F3e2X10VyUK6oT899LeVo/Vk6rW3V/i9PauP8hvTqIgoiCiIKIgoiCiIKIgoiCiIKIgoiCiIKIgoiCiIKIgoiCiIKIgoiCiIJI44J+AF/PWYoRfRTiAAAAAElFTkSuQmCC");
      background-repeat: repeat-x;
      background-size: auto 32px;
    }
  }

  .ticket-dialog-head {
    text-align: center;
    background-color: #edf7f8;
    padding: 30px 15px 10px;

    > div {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .ticket-dialog-body {
    text-align: center;
    background-color: white;
  }
}

.ticket {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;

  .card-header {
    display: flex;
    background-color: rgba(24, 157, 170, 0.08);
  }

  @media screen and(min-width: 960px) {
    flex-direction: row;

    .card-header {
      max-width: 320px;
      font-size: 20px;
      flex-direction: column;
    }

    .card-body {
      flex: 1;
      flex-grow: 1;
    }
  }
}

.empty-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  align-content: center;
  justify-content: center;
  flex: 1;
  flex-grow: 1;
}

.inactive::before {
  background: rgb(224 224 224 / 73%) !important;
  box-shadow: inset 0 -3px 3px rgb(0 0 0 / 5%) !important;
}

.center-tab.inactive::before {
  background: rgb(224 224 224 / 73%) !important;
  box-shadow: inset 0 -8px 3px rgb(0 0 0 / 5%) !important;
}

.tab-content {
  position: relative;
  top: -1px;
  display: flex;
  flex-direction: column;
  min-height: 400px;
  background: white;
  border-radius: 0 0 $radiusDesktop $radiusDesktop;
  box-shadow: 0px 7px 7px 1px rgb(0 0 0 / 9%);

  @media screen and (max-width: 600px) {
    border-radius: 0 0 $radiusMobile $radiusMobile;
  }
}

@media screen and (max-width: 600px) {
  .cus-tab {
    font-size: 14px;
  }
}
</style>
